import React from 'react';
import './index.scss';
import { ConfirmPopup } from '../../../../common/popup';
import {
  addPersonalAlert,
  editPersonalAlert,
} from '../../../../main-layout/header/right/alerts/reducer';
import { REDUCER_NAME } from '../../reducer';
import { connect } from 'react-redux';
import DropDown from './../../../../common/dropdown/DropDown';
import { I18n } from 'react-redux-i18n';
import SearchBox from '../../common/SearchBox';
import Checkbox from '../../../../common/Checkbox';

class PersonalForm extends React.Component {
  constructor(props) {
    super(props);
    const { data } = this.props;
    this.state = {
      alertTypeById: {},
      alertTypeIds: [],
      alertCodeById: {},
      alertCodeIds: [],
      currentAlertType: this.getCurrentAlertType(),
      currentAlertCode: this.getCurrentAlertCode(),
      email: data ? data.email : true,
      notification: data ? data.notification : true,
      currentSearch: this.getCurrentSearch(),
      error: {
        isShow: false,
        title: '',
        message: '',
      },
    };
  }

  componentDidMount() {
    const { alertTypes } = this.props;
    if (alertTypes.length) {
      this.setAlertCodeState(this.props);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { alertTypes, i18n } = this.props;
    if (alertTypes.length !== nextProps.alertTypes.length) {
      this.setAlertCodeState(nextProps);
    }
    if (i18n.locale !== nextProps.locale) {
      this.setAlertCodeState(nextProps);
    }
  }

  setAlertCodeState = props => {
    const [defaultAlertType] = props.alertTypes;
    const { alertTypeById, alertTypeIds } = this.getAlertType(props);
    const { alertCodeById, alertCodeIds } = this.getAlertCode(
      this.state.currentAlertType
        ? alertTypeById[this.state.currentAlertType].alertDefinitions
        : defaultAlertType.alertDefinitions,
    );

    const currentAlertType =
      this.state.currentAlertType || defaultAlertType.code;
    const currentAlertCode =
      this.state.currentAlertCode || defaultAlertType.alertDefinitions[0].code;

    this.setState({
      alertTypeById,
      alertTypeIds,
      alertCodeById,
      alertCodeIds,
      currentAlertType,
      currentAlertCode,
    });
  };

  getAlertType = props => {
    const { alertTypes } = props;
    const alertTypeById = {};
    const alertTypeIds = [];
    alertTypes.forEach(type => {
      alertTypeById[type.code] = type;
      alertTypeIds.push(type.code);
    });

    return { alertTypeById, alertTypeIds };
  };

  getAlertCode = codes => {
    const alertCodeById = {};
    const alertCodeIds = [];
    codes.forEach(item => {
      alertCodeById[item.code] = item;
      alertCodeIds.push(item.code);
    });

    return { alertCodeById, alertCodeIds };
  };

  getCurrentAlertType = () => {
    const { data } = this.props;

    return data ? data.alertGroupCode : '';
  };

  getCurrentAlertCode = () => {
    const { data } = this.props;
    return data ? data.alertCode : '';
  };

  savePersonalAlert = () => {
    const { currentAlertCode, email, notification, currentSearch } = this.state;
    const { data, i18n } = this.props;
    if (!currentSearch.organCode) {
      this.setState({
        error: {
          isShow: true,
          title: I18n.t('alerts.errorFormTitle'),
          message: I18n.t('alerts.errorFormMessage'),
        },
      });
      return;
    }
    const postData = {
      organCode: currentSearch.organCode,
      notification,
      email,
      alertCode: currentAlertCode,
      language: i18n.locale,
    };
    if (!data) {
      this.createPersonalAlert(postData);
    } else {
      this.editPersonalAlert(postData);
    }
  };

  handleAfterPromise = errors => {
    const { hideForm } = this.props;
    if (!errors) {
      hideForm();
      return;
    }

    this.setState({
      error: {
        isShow: true,
        title: I18n.t('alerts.errorFormTitle'),
        message: errors,
      },
    });
  };

  createPersonalAlert = data => {
    const { addPersonalAlert } = this.props;
    addPersonalAlert(data).then(this.handleAfterPromise);
  };

  editPersonalAlert = postData => {
    const { data, editPersonalAlert } = this.props;
    editPersonalAlert({
      ...postData,
      personalAlertId: data.personalAlertId,
    }).then(this.handleAfterPromise);
  };

  changeAlertType = type => {
    const { alertTypeById } = this.state;
    const alertType = alertTypeById[type];
    const { alertCodeById, alertCodeIds } = this.getAlertCode(
      alertType.alertDefinitions,
    );
    const currentAlertCode = alertType.alertDefinitions[0].code;
    this.setState({
      currentAlertType: type,
      alertCodeById,
      alertCodeIds,
      currentAlertCode,
    });
  };

  changeAlertCode = code => {
    this.setState({
      currentAlertCode: code,
    });
  };

  onCheckBoxChange = e => {
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };

  onSearchChange = currentSearch => {
    this.setState({
      currentSearch: currentSearch || {},
    });
  };

  getCurrentSearch = () => {
    const { data } = this.props;
    if (!data) {
      return {};
    }

    return {
      organCode: data.organCode,
      ticker: data.ticker,
    };
  };

  clearMessage = () => {
    this.setState({
      error: {},
    });
  };

  render() {
    const {
      alertTypeById,
      alertTypeIds,
      alertCodeById,
      alertCodeIds,
      currentAlertCode,
      currentAlertType,
      currentSearch,
      email,
      notification,
      error,
    } = this.state;
    const { hideForm } = this.props;

    return (
      <div className="edit-setting-personal d-flex flex-column">
        {error.isShow && <div className="error mb-10">{error.message}</div>}
        <div className="list-filter mb-5">
          <SearchBox
            currentSearch={currentSearch}
            onChange={this.onSearchChange}
          />
        </div>

        <div className="body-setting-personal d-flex flex-column mt-5 flex-fill">
          <div className="body-col-content d-flex flex-column">
            <div className="body-row-content">
              <span className="text-transparent text-font-weight ">
                {I18n.t('alertPersonal.editSetting.applyTo', {
                  ticker: currentSearch.ticker || '',
                })}
                <span className="text-font-weight" />
              </span>
            </div>

            <div className="body-row-content d-flex align-items-end">
              <div>
                <span className="text-font-weight mr-10 text-opacity">
                  {I18n.t('alertPersonal.editSetting.conditions')}
                </span>
              </div>

              <div className="line-drop condition-drop-down mr-5">
                <DropDown
                  listKey={alertTypeIds}
                  listDataByKey={alertTypeById}
                  currentKey={currentAlertType}
                  keyTitle={'name'}
                  change={this.changeAlertType}
                  isI18n={true}
                />
              </div>

              <div className="line-drop condition-drop-down mr-5 ml-5">
                <DropDown
                  listKey={alertCodeIds}
                  listDataByKey={alertCodeById}
                  currentKey={currentAlertCode}
                  keyTitle={'name'}
                  change={this.changeAlertCode}
                  isI18n={true}
                />
              </div>
            </div>
          </div>
          <div className="body-col-content d-flex mt-13 flex-fill">
            <div>
              <span className="text-font-weight text-opacity">
                {I18n.t('alertPersonal.editSetting.notificationPreferences')}
              </span>
            </div>
            <div className="body-row-content">
              <div className="radio-alert-setting-personal">
                <Checkbox
                  isChecked={notification}
                  onChange={this.onCheckBoxChange}
                  name="notification"
                  label={I18n.t('alertPersonal.editSetting.notifications')}
                />

                <Checkbox
                  isChecked={email}
                  onChange={this.onCheckBoxChange}
                  name="email"
                  label={I18n.t('alertPersonal.editSetting.email')}
                />
              </div>
            </div>
          </div>

          <div className="body-row-content d-flex justify-content-center">
            <button
              className="btn-remove-delete"
              onClick={this.savePersonalAlert}
            >
              {I18n.t('common.button.save')}
            </button>
            <button className="btn-remove-cancel" onClick={hideForm}>
              {I18n.t('common.button.cancel')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  alertTypes: state[REDUCER_NAME].personalAlertTypes,
});

const mapDispatchToProps = {
  addPersonalAlert,
  editPersonalAlert,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PersonalForm);
